import classNames from 'classnames'
import classes from './OauthSignInButton.module.scss'

const OauthSignInButton = () => {
  const providerHost = process.env.REACT_APP_OAUTH_PROVIDER_HOST
  const baseUrl = process.env.REACT_APP_BASE_URL
  const clientId = process.env.REACT_APP_OAUTH_CLIENT_ID

  const redirectUrl = `${baseUrl}/login/oauth`
  const signInUrl = `${providerHost}/oauth/authorize?client_id=${clientId}` +
    `&redirect_uri=${encodeURIComponent(redirectUrl)}&response_type=code&scope=openid`

  return (
    <a href={signInUrl} style={{ textDecoration: 'none' }}>
      <button type='button' className={classNames(classes.oauthSignInButton)}>
        Sign In With Golf Genius
      </button>
    </a>
  )
}

export default OauthSignInButton
